import React from "react";
import ProjectLanguages from "../projectLanguages/ProjectLanguages";
import ProjectLinks from "../ProjectLinks/ProjectLinks";
import "./ProjectCard.css";
import { Fade } from "react-awesome-reveal";
import { Icon } from "@iconify/react";

export default function ProjectCard({ repo, theme }) {
  console.log(repo);

  return (
    <div style={{ height: "100%" }}>
      <Fade
        bottom
        duration={2000}
        distance="40px"
        className="project-card-reveal"
        style={{ height: "100%" }}
      >
        <div
          className="project-card"
          key={repo.id}
          style={{
            backgroundColor: theme.projectCard,
            border: `1px solid ${
              theme.name === "dark"
                ? "rgba(255, 255, 255, 0.05)"
                : "rgba(0, 0, 0, 0.05)"
            }`,
            "--accent-color": theme.accentColor,
            "--accent-glow": `${theme.accentColor}33`,
          }}
        >
          <div>
            <div className="repo-name-div">
              <Icon
                icon="octicon:repo-16"
                className="repo-icon"
                style={{ color: theme.accentColor }}
              />
              <p className="repo-name" style={{ color: theme.text }}>
                {repo.name}
              </p>
            </div>
            <p
              className="repo-description"
              style={{ color: theme.secondaryText }}
            >
              {repo.description}
            </p>
          </div>
          <div className="flexDiv">
            <div className="repo-details Leftitem">
              <ProjectLanguages logos={repo.languages} />
            </div>
            <div className="repo-details Rightitem">
              <ProjectLinks logos={repo.links} />
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}
